import type { ComponentType } from 'react';
import type { SvgIconProps } from '@mui/material';
import HomeRounded from '@mui/icons-material/HomeRounded';
import StickyNote2Rounded from '@mui/icons-material/StickyNote2Rounded';
import PaymentsRounded from '@mui/icons-material/PaymentsRounded';
import ShoppingCartRounded from '@mui/icons-material/ShoppingCartRounded';
import FolderRounded from '@mui/icons-material/FolderRounded';
import CalendarMonthRounded from '@mui/icons-material/CalendarMonthRounded';
import BarChartRounded from '@mui/icons-material/BarChartRounded';
import ChatRounded from '@mui/icons-material/ChatRounded';
import LibraryMusicRounded from '@mui/icons-material/LibraryMusicRounded';
import OndemandVideoRounded from '@mui/icons-material/OndemandVideoRounded';
import WorkRounded from '@mui/icons-material/WorkRounded';
import SpeedRounded from '@mui/icons-material/SpeedRounded';
import PasswordRounded from '@mui/icons-material/PasswordRounded';
import SettingsRounded from '@mui/icons-material/SettingsRounded';

export type NavItem = {
  label: string;
  path: string;
  icon: ComponentType<SvgIconProps>;
  matchPrefix: string;
};

export const PRIMARY_NAV: NavItem[] = [
  { label: 'Home', path: '/dashboard', icon: HomeRounded, matchPrefix: '/dashboard' },
  { label: 'Notes', path: '/notes', icon: StickyNote2Rounded, matchPrefix: '/notes' },
  { label: 'Payments', path: '/payments', icon: PaymentsRounded, matchPrefix: '/payments' },
  { label: 'Grocery', path: '/grocery', icon: ShoppingCartRounded, matchPrefix: '/grocery' },
  { label: 'Documents', path: '/documents', icon: FolderRounded, matchPrefix: '/documents' },
  { label: 'Calendar', path: '/calendar', icon: CalendarMonthRounded, matchPrefix: '/calendar' },
  { label: 'Reports', path: '/reports', icon: BarChartRounded, matchPrefix: '/reports' },
  { label: 'Chat', path: '/chat', icon: ChatRounded, matchPrefix: '/chat' },
  { label: 'Tunes', path: '/tunes', icon: LibraryMusicRounded, matchPrefix: '/tunes' },
  { label: 'Videos', path: '/videos', icon: OndemandVideoRounded, matchPrefix: '/videos' },
  { label: 'PMA', path: '/pma', icon: WorkRounded, matchPrefix: '/pma' },
  { label: 'Password Generator', path: '/password-generator', icon: PasswordRounded, matchPrefix: '/password-generator' },
  { label: 'Speed Test', path: '/internet-speed', icon: SpeedRounded, matchPrefix: '/internet-speed' },
  { label: 'Settings', path: '/settings', icon: SettingsRounded, matchPrefix: '/settings' },
];

export const PUBLIC_PATHS = ['/', '/login', '/about', '/contact'];
